import { mapState } from 'vuex'
import TableFilter from '@ebg/vue-common/src/components/common/tablefilter/TableFilter.vue'
import draggable from 'vuedraggable'

export default {
  name: 'TableviewExtended',
  props: {
    fields: Array,
    items: Array,
    expandableConfig: Object,
    loading: Boolean,
    filters: Object,
    filterValues: Object,
    exportCols: Array,
    displayFilterActions: {
      type: Boolean,
      default: false
    },
    displayColFiltersAlways: {
      type: Boolean,
      default: false
    },
    displayReload: {
      type: Boolean,
      default: true
    },
    filterActions: {
      type: Object,
      default: function () {
        return { filters: true, reload: true, download: true }
      }
    },
    loadDataOnMounted: {
      type: Boolean,
      default: false
    },
    tableClass: {
      type: String,
      default: 'table-striped table-hover'
    },
    parentName: {
      type: String,
      default: null
    },
    tableSorting: {
      type: Object,
      default: null
    },
    rowClassText: Function,
    localPaging: {
      type: Boolean,
      default: false
    },
    perPage: {
      type: Number,
      default: 20
    },
    filterActionColClass: {
      type: String,
      default: 'col-md-12'
    },
    filterActionAlign: {
      type: String,
      default: 'text-end'
    },
    localFilterClass: {
      type: String,
      default: ''
    },
    displayClearFilters: {
      type: Boolean,
      default: false
    },
    smallScreenCards: {
      type: Boolean,
      default: false
    },
    cardClass: {
      type: String,
      default: 'card bg-primary bg-opacity-25 p-2 mb-1'
    },
    modelClassName: {
      type: String,
      default: null
    },
    showUserTableSetupOption: {
      type: Boolean,
      default: true
    },
    allowOnlyOneExpandedRow: {
      type: Boolean,
      default: false
    },
    showChevron: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      downloading: false,
      clearingCache: false,
      displayColFilters: false,
      sortBy: null,
      sortDesc: true,
      paging: { limit: this.perPage, page: 1, pages: 0 },
      localFilters: { },
      selectedRowIdx: null,
      selectedExportCols: [],
      showPopup: false,
      columnSetup: [],
      isDragging: false,
      userColumnSetup: [],
      localfields: [],
      mounted: false
    }
  },
  components: {
    draggable,
    TableFilter
  },
  computed: {
    ...mapState(['config', 'sessionUserTableSetup']),
    showAllFilters () {
      return this.smallScreenCards && window.innerWidth < 992
    },
    dragOptions () {
      return {
        animation: 0,
        group: 'description',
        disabled: false,
        ghostClass: 'ghost'
      };
    },
    localTableName () {
      return (this.$route?.name + '.' + this.tableParentName)
    },
    columnFiltersActive () {
      return !!(this.showUserTableSetupOption && this.fields.find(el => el.key == 'actions'));
    },
    localFieldsFiltered () {
      return this.localfields.filter(localField => localField.visible);
    },
    sessionTableConfig () {
      if (this.sessionUserTableSetup && this.sessionUserTableSetup[this.localTableName]) {
        return this.sessionUserTableSetup[this.localTableName].config ? this.sessionUserTableSetup[this.localTableName].config : this.sessionUserTableSetup[this.localTableName];
      }
      return null;
    },
    quickfilters () {
      const res = {};
      for (const key in this.filters) {
        if (!Object.prototype.hasOwnProperty.call(this.filters[key], 'colOnlyFilter') || this.filters[key].colOnlyFilter === false) {
          res[key] = this.filters[key];
        }
      }
      return res;
    },
    tableParentName () {
      if (this.parentName) {
        return this.parentName;
      }
      return (this?.$parent?.$options?.name) ?? this.$attrs.name;
    },
    hasColFilters () {
      if (this.fields && this.filters) {
        return (this.fields.filter(el => Object.prototype.hasOwnProperty.call(el, 'filterKey')).length > 0);
      }
      return false;
    },
    localFilterFields () {
      const filterFields = {};
      const self = this;
      this.fields.forEach(function (el) {
        if (Object.prototype.hasOwnProperty.call(self.localFilters, el.key)) {
          filterFields[el.key] = el;
        }
      });
      return filterFields;
    },
    filteredItems () {
      if (this.items) {
        Object.keys(this.items).forEach(key => {
          // set index so if you edit you can reference correct item
          this.items[key].itemIndex = key;
        });
        return this.items.filter((el) => {
          let res = true;
          if (res) {
            Object.keys(this.localFilters).forEach((filterKey) => {
              if (res && (this.localFilters[filterKey] || this.localFilters[filterKey] == '0') && this.localFilterFields[filterKey]) {
                let filterText = this.localFilters[filterKey].toString().toLowerCase();
                let reverse = false;
                if (filterText && filterText.length > 0) {
                  if (filterText[0] == '!') {
                    reverse = true;
                    filterText = filterText.substring(1);
                  }
                }
                let text = this.BasicHelper.getObjectValueByString(el, filterKey);
                if (typeof text == 'boolean') {
                  text = text ? '1' : '0';
                }
                if (reverse && filterText.length == 0) {
                  if (text == '' || text == null || text == 0) {
                    res = true;
                  } else {
                    res = false;
                  }
                } else if (text !== null) {
                  text += '';
                  if (this.localFilterFields[filterKey].format === 'formatFromConfig') {
                    text = this.BasicHelper.getConfigValue(this.localFilterFields[filterKey].configKey, 'id', text, 'name', true)
                  } else if (this.localFilterFields[filterKey].valFilter) {
                    text = this.$options.filters[this.localFilterFields[filterKey].valFilter](text);
                  }
                  if (reverse) {
                    res = !(text.toLowerCase().includes(filterText));
                  } else {
                    res = text.toLowerCase().includes(filterText);
                  }
                } else {
                  res = false;
                }
              }
            });
          }
          return res;
        });
      }
      return [];
    },
    tableItems () {
      if (this.loading) {
        return null;
      }
      if (this.localPaging && this.items && this.filteredItems) {
        let resItems = this.filteredItems;
        if (this.filterValues && this.filterValues.orderByMulti) {
          this.filterValues.orderByMulti.forEach(el => {
            if (el.direction) {
              const reverse = el.direction === 'DESC';
              resItems = this.BasicHelper.sortArrayByKeyValue(resItems, el.key, reverse);
            }
          });
        } else if (this.sortBy) {
          resItems = this.BasicHelper.sortArrayByKeyValue(resItems, this.sortBy, this.sortDesc);
        }
        this.paging.pages = Math.ceil(this.paging.total / this.paging.limit);
        if (this.paging.pages < this.page) {
          this.paging.page = this.paging.pages;
        }
        if (this.paging.total > this.paging.limit) {
          resItems = resItems.slice((this.paging.page - 1) * this.paging.limit, this.paging.page * this.paging.limit);
        }
        return resItems;
      }
      return this.items;
    },
    cardFields () {
      return this.fields.filter(el => el.label !== '');
    },
    fieldActions () {
      return this.fields.find(el => el.key === 'actions');
    }
  },
  methods: {
    getOrderByMultiIndex (colKey) {
      return this.filterValues.orderByMulti.findIndex(obj => obj.key === colKey);
    },
    toggleSortDirection (colKey, popExisting = true) {
      let index = -1;
      if (this.filterValues && this.filterValues.orderByMulti) {
        if (popExisting) {
          this.filterValues.orderByMulti = this.filterValues.orderByMulti.filter(el => {
            return (el.key === colKey);
          });
        }
        index = this.getOrderByMultiIndex(colKey);
      }
      if (index === -1) {
        if (!this.filterValues) {
          this.filterValues = {
            orderByMulti: []
          };
        }
        if (this.filterValues && !this.filterValues.orderByMulti) {
          this.filterValues.orderByMulti = [];
        }
        this.filterValues.orderByMulti.push({ key: colKey, direction: 'ASC' })
      } else if (this.filterValues && this.filterValues.orderByMulti) {
        const currentDirection = this.filterValues.orderByMulti[index].direction;
        let newDirection = null;
        if (currentDirection === 'ASC') {
          newDirection = 'DESC';
        } else if (currentDirection === 'DESC') {
          newDirection = null;
        } else {
          newDirection = 'ASC';
        }
        this.filterValues.orderByMulti[index].direction = newDirection;
      }
      this.$emit('saved');
    },
    toggleMultiSortDirection (colKey) {
      this.toggleSortDirection(colKey, false);
    },
    toggleRow (item, index, event) {
      if (this.expandableConfig) {
        let allowExpand = true;
        let targetEl = event.target;
        while (targetEl) {
          if (typeof targetEl.className.includes === 'function') {
            if (targetEl.className.includes('table-actions')) {
              allowExpand = false;
              break;
            }
            if (targetEl.className.includes('tableview')) {
              break;
            }
          }
          targetEl = targetEl.parentElement;
        }
        if (event && event.target != undefined && event.target.tagName != undefined && ['INPUT', 'SELECT', 'BUTTON'].includes(event.target.tagName)) {
          allowExpand = false
        }
        if (allowExpand) {
          if (this.allowOnlyOneExpandedRow && (item._showDetails === undefined || item._showDetails === false)) {
            this.items.forEach(item => {
              if (item._showDetails) {
                item._showDetails = false;
              }
            });
          }
          item._showDetails = !item._showDetails;

          this.$forceUpdate();
        }
      }
      this.$emit('toggleRow', item);
    },
    actionVisible (actionConfig, item, index) {
      if (actionConfig) {
        if (actionConfig.useFunc) {
          return actionConfig.func(item, index);
        }
        const paramVal = this.BasicHelper.getObjectValueByString(item, actionConfig.param);
        if (actionConfig.notCheck) {
          if (actionConfig.valueIn) {
            if (!actionConfig.valueIn.find(val => (val == paramVal))) {
              return true;
            }
          } else if (!actionConfig.valueIn && paramVal != actionConfig.value) {
            return true;
          }
        } else {
          if (actionConfig.valueIn) {
            if (actionConfig.valueIn.find(val => (val == paramVal))) {
              return true;
            }
          } else if (paramVal == actionConfig.value) {
            return true;
          }
        }
        return false;
      }
      return true;
    },
    updateFilter (key, value) {
      this.$emit('updateFilter', key, value);
    },
    comparisonModeChange (mode, key) {
      if (!this.filterValues._reversedFilters_) {
        this.filterValues._reversedFilters_ = [];
      }

      const idx = this.filterValues._reversedFilters_.indexOf(key);

      if (mode === '!=') {
        if (idx === -1) {
          this.filterValues._reversedFilters_.push(key);
        }
      } else {
        if (idx !== -1) {
          this.filterValues._reversedFilters_.splice(idx, 1);
        }
      }

      this.$emit('saved');
    },
    updateSort (ctx) {
      this.sortBy = ctx.sortBy;
      this.sortDesc = ctx.sortDesc;
      this.$emit('updateSort', ctx.sortBy, ctx.sortDesc);
    },
    isExpandVisible (config, item) {
      if (config.ifconfig) {
        const val = this.BasicHelper.getObjectValueByString(item, config.ifconfig.param);
        let res = (val == config.ifconfig.value);
        if (config.ifconfig.notCheck) {
          res = !res;
        }
        return res;
      }
      return true;
    },
    downloadTable (paramSelected) {
      if (!paramSelected && this.exportCols) {
        this.$refs.searchchecklist.showModal();
      } else if (!this.downloading) {
        this.$emit(
          'download',
          this.$refs.tableview.innerHTML,
          (this.selectedExportCols)
        );
      }
    },
    setDownloading (value) {
      this.downloading = value;
    },
    headerColClick (colname, item, e) {
      if (this.hasColFilters && !this.isDragging) {
        if (colname === 'actions') {
          if (e && e.target && e.target.attributes && e.target.attributes.class && (e.target.attributes.class.value.includes('bi-filter') || e.target.attributes.class.value.includes('table-actions'))) {
            this.displayColFilters = !this.displayColFilters;
            this.$emit('saved');
          }
        } else if (!this.displayColFilters) {
          this.displayColFilters = true;
          this.$emit('saved');
        }
      }
    },
    togglePopup () {
      this.showPopup = !this.showPopup
    },
    closePopup (e) {
      if (!['removeAllColumns', 'addAllColumns'].includes(e?.target?.id)) {
        this.showPopup = false;
      }
    },
    initSetup () {
      this.localfields = [];
      if (this.fields) {
        Object.keys(this.fields).forEach(fieldindex => {
          this.localfields.push({
            key: this.fields[fieldindex].key,
            visible: !(this.fields[fieldindex].visible === false),
            label: this.fields[fieldindex].label,
            fieldindex: fieldindex
          })
        });
      }
      this.userColumnSetup = [];
      this.columnSetup = [];
      if (this.columnFiltersActive && this.sessionTableConfig) {
        Object.values(this.sessionTableConfig).forEach(sessiontable => {
          if (sessiontable && sessiontable.key) {
            const fieldmatch = this.localfields.find(field => field.key == sessiontable.key);
            if (fieldmatch) {
              if (sessiontable.visible === false) {
                fieldmatch.visible = false;
              } else if (!this.userColumnSetup.find(el => el.key === sessiontable.key)) {
                const userColSetup = this.BasicHelper.cloneObject(fieldmatch);
                userColSetup.visible = true;
                userColSetup.visibleSearch = true;
                userColSetup.order = sessiontable.order;
                this.userColumnSetup.push(userColSetup);
              }
            }
          }
        });
        this.userColumnSetup.sort((a, b) => a.order - b.order);
      }
      if (this.userColumnSetup.length == 0) {
        this.addAllColumns(true)
      }
      this.localfields.forEach((header, idx) => {
        if (!['actions', ''].includes(header.key)) {
          let findUserTableSetup = this.userColumnSetup.find(columnSetup => columnSetup.key == header.key)
          if (!findUserTableSetup) {
            if (header.visible === false) {
              let matchcol = this.columnSetup.find(columnSetup => columnSetup.key == header.key);
              if (!matchcol) {
                matchcol = this.BasicHelper.cloneObject(header);
                matchcol.order = this.columnSetup.length + 9999;
                matchcol.visible = true;
                matchcol.visibleSearch = true;
                matchcol.label = this.getColumnSelectLabel(matchcol);
                this.columnSetup.push(matchcol);
              }
              this.localfields[idx].visible = false;
            } else {
              findUserTableSetup = this.BasicHelper.cloneObject(header);
              findUserTableSetup.order = this.userColumnSetup.length + 9999;
              findUserTableSetup.visible = true;
              findUserTableSetup.visibleSearch = true;
              findUserTableSetup.label = this.getColumnSelectLabel(findUserTableSetup);
              this.userColumnSetup.push(findUserTableSetup);
              this.localfields[idx].visible = true;
            }
          } else {
            this.localfields[idx].order = findUserTableSetup.order;
            this.localfields[idx].visible = findUserTableSetup.visible;
          }
        } else {
          this.localfields[idx].visible = false
        }
        this.localfields[idx].initOrder = idx
      });
      this.orderUserColumns()
      this.setEmptyColumnLabel()
    },
    setEmptyColumnLabel () {
      this.userColumnSetup.forEach((header, idx) => {
        if (!['actions', ''].includes(header.key) && header.label == '') {
          this.userColumnSetup[idx].label = this.getColumnSelectLabel(header);
        }
      })
      this.columnSetup.forEach((header, idx) => {
        if (!['actions', ''].includes(header.key) && header.label == '') {
          this.userColumnSetup[idx].label = this.getColumnSelectLabel(header);
        }
      })
    },
    searchColumnSetupChange (text = '') {
      this.columnSetup.forEach((columnSetup, idx) => {
        this.columnSetup[idx].visibleSearch = columnSetup.label.toLowerCase().includes(text.toLowerCase()) || text.length == 0
      });
      this.$forceUpdate();
    },
    searchUserColumnSetupChange (text = '') {
      this.userColumnSetup.forEach((columnSetup, idx) => {
        this.userColumnSetup[idx].visibleSearch = columnSetup.label.toLowerCase().includes(text.toLowerCase()) || text.length == 0
      });
      this.$forceUpdate();
    },
    localFieldVisibleChange () {
      this.localfields.forEach((localfield, idx) => {
        const findUserColumn = this.userColumnSetup.find(el => el.key == localfield.key);
        if (!findUserColumn && !['actions', ''].includes(localfield.key) && this.userColumnSetup.length > 0) {
          this.localfields[idx].visible = false;
        } else {
          this.localfields[idx].visible = true;
        }
      });
    },
    addAllColumns (initSetup = false) {
      this.userColumnSetup = []
      this.localfields.forEach((localfield, idx) => {
        if (!['actions', ''].includes(localfield.key) && (localfield.visible || !initSetup)) {
          const newEl = this.BasicHelper.cloneObject(localfield)
          newEl.visibleSearch = true
          newEl.visible = true
          newEl.order = idx
          newEl.label = this.getColumnSelectLabel(newEl);
          this.userColumnSetup.push(newEl)
        }
      })
      this.columnSetup = []
      this.isDragging = true;
      if (!initSetup) {
        this.saveUserColumnSetup()
      }
    },
    removeAllColumns () {
      this.columnSetup = []
      this.localfields.sort((a, b) => a.initOrder - b.initOrder);
      this.localfields.forEach((localfield, idx) => {
        if (!['actions', ''].includes(localfield.key)) {
          const el = this.BasicHelper.cloneObject(localfield)
          el.order = idx
          el.visibleSearch = true
          el.visible = true
          el.label = this.getColumnSelectLabel(el);
          this.columnSetup.push(el)
        }
      });
      this.userColumnSetup = []
      this.isDragging = true
      this.saveUserColumnSetup();
    },
    orderUserColumns () {
      this.userColumnSetup.forEach((userColumn, idx) => {
        this.userColumnSetup[idx].order = idx
        this.userColumnSetup[idx].visible = true
      });
      this.localfields.forEach((header, idx) => {
        const findUserColumn = this.userColumnSetup.find(el => el.key == header.key)
        if (!findUserColumn) {
          if (['actions', ''].includes(header.key)) {
            this.localfields[idx].visible = true;
          } else {
            const sessionFieldConfig = (this.sessionTableConfig ? this.sessionTableConfig.find(el => (el && el.key == header.key)) : null);
            if (sessionFieldConfig) {
              this.localfields[idx].visible = !!sessionFieldConfig.visible;
            } else if (this.userColumnSetup.length > 0) {
              this.localfields[idx].visible = false;
            } else {
              const fieldconfig = this.fields.find(el => el.key == header.key);
              if (fieldconfig.visible === false) {
                this.localfields[idx].visible = false;
              } else {
                this.localfields[idx].visible = true;
              }
            }
          }
          this.localfields[idx].order = 9999
        } else {
          this.localfields[idx].visible = true;
          this.localfields[idx].order = this.BasicHelper.cloneObject(findUserColumn).order
        }
      });
      this.localfields.sort((a, b) => a.order - b.order);
      this.$forceUpdate()
    },
    onMove (event) {
    },
    onDragchange (event, dragList) {
      if (dragList == 'userColumnSetup') {
        this.saveUserColumnSetup()
        this.searchColumnSetupChange()
        this.searchUserColumnSetupChange();
        this.localFieldVisibleChange();
      }
    },
    saveUserColumnSetup () {
      if (this.columnFiltersActive) {
        this.orderUserColumns();
        const userColumnSetup = [];
        this.userColumnSetup.forEach(el => {
          userColumnSetup.push({ key: el.key, order: el.order, visible: true });
        });
        if (userColumnSetup.length > 0) {
          this.columnSetup.forEach(el => {
            userColumnSetup.push({ key: el.key, visible: false });
          });
        }

        const reqData = {
          tableSetupName: this.localTableName,
          userColumnSetup: userColumnSetup
        }
        this.$store.commit('UPDATE_TABLEVIEW_CONFIG', { data: reqData.userColumnSetup, key: reqData.tableSetupName });

        if (process.env.VUE_APP_TABLEVIEW_BACKEND == 1) {
          this.ApiRequest.request('userTableSetup/edit', this.ApiRequest.REQUEST_POST, reqData, () => {});
        }
        this.isDragging = false;
      }
    },
    getTableRowClass (item, type) {
      if (type === 'row' && this.rowClassText) {
        return this.rowClassText(item);
      }
      return '';
    },
    getFilterValues () {
      const filterVals = {};
      for (const filterKey in this.filters) {
        if (this.filters[filterKey].type === 'checkboxEnabler') {
          if (this.filterValues[filterKey]) {
            for (const filterSub in this.filters[filterKey].sub) {
              filterVals[filterSub] = this.filterValues[filterSub];
            }
          }
        } else {
          if ((!this.displayColFilters && (this.filters[filterKey].colOnlyFilter !== true)) ||
            ((this.displayColFiltersAlways || this.displayColFilters) && (this.filters[filterKey].notWithColFilter !== true))
          ) {
            filterVals[filterKey] = this.filterValues[filterKey];
          }
        }
      }
      filterVals.displayColFilters = this.displayColFilters;
      return filterVals;
    },
    clearCache () {
      this.clearingCache = true;
      const self = this;
      this.ApiRequest.request('admin/clear-cache?parent_component=' + this.$parent.$options.name, this.ApiRequest.REQUEST_GET, {}, function () {
        self.clearingCache = false;
      })
    },
    cellEventCalled (e, ...args) {
      this.$emit(e, args);
    },
    downloadTableData (reqPath, exportCols) {
      this.setDownloading(1);
      this.ApiRequest.request(this.ApiRequest.addGetParamsToPath(reqPath, { download: 1 }), this.ApiRequest.REQUEST_DOWNLOAD, { cols: exportCols }, (response) => {
        if (response.error) {
          this.$store.commit('toastAdd', {
            context: 'danger',
            message: this.ApiRequest.getApiResponseErrorMessage(response, {})
          })
        }
        this.setDownloading(0);
      });
    },
    getColumnSelectLabel (item) {
      if (item.label !== '') {
        return item.label;
      }
      const idx = this.fields.findIndex(el => el.key == item.key);
      return this.$t('tableColumnSetup.colnumber', { 0: idx + 1 });
    }
  },
  mounted () {
    if (this.tableSorting && this.tableSorting.item) {
      this.sortBy = this.tableSorting.item;
      this.sortDesc = (this.tableSorting.direction === 'DESC');
    } else {
      this.sortBy = null;
      this.sortDesc = true;
    }
    this.displayColFilters = (this.filterValues && this.filterValues.displayColFilters);
    if (this.loadDataOnMounted) {
      this.$emit('saved');
    }
    this.initSetup();
    this.mounted = true;
  },
  watch: {
    filteredItems: {
      immediate: true,
      handler (val) {
        if (this.localPaging) {
          this.paging.total = (this.filteredItems ? this.filteredItems.length : 0);
          this.paging.page = 1;
        }
      }
    },
    items: {
      immediate: true,
      handler (val) {
        this.localFilters = {};
      }
    },
    fields: {
      immediate: true,
      handler (val) {
        if (this.mounted) {
          this.initSetup();
        }
      }
    },
    watch: {
      '$route' () {
        if (this.mounted) {
          this.initSetup();
        }
      }
    }
  }
}
